import axios from "axios";
import moment from "moment";
import base from "../../../config";

//Create function to verify ServiceNowTicket format (RITM or Opportunity ID) - Legacy function for backward compatibility
export function checkServiceNowTicket(value, isChecked, config) {
  const trimmed = value && value.trim() || "";

  // Mandatory check
  if (!trimmed) {
    return config || isChecked; // Required when not in config and no SAP Contract
  }

  // Format validation: RITM (case insensitive) or exactly 10-digit Opportunity ID
  return /^RITM\d{8}$/i.test(trimmed) || /^\d{1,10}$/.test(trimmed);
}

//Create function to verify RITM format
export function checkRITM(value) {
  const trimmed = value && value.trim() || "";

  // Mandatory check
  if (!trimmed) {
    return false;
  }

  // Format validation: RITM (case insensitive) followed by exactly 8 digits
  return /^RITM\d{8}$/i.test(trimmed);
}

//Create function to verify Opportunity ID format
export function checkOpportunityID(value) {
  const trimmed = value && value.trim() || "";

  // Mandatory check
  if (!trimmed) {
    return false;
  }

  // Format validation: numeric, 1-10 digits
  return /^\d{1,10}$/.test(trimmed);
}
//Create function to verify whether WBSECode begin with 4 capital letters and end with 4 numbers
export function checkWBSECode(input) {
  return /(?=^.{8}$)(?=(.*[a-zA-Z]){1,6})(?=(.*[0-9]){2,7})/.test(input);
}

//Create function to verify whehter MonthlyTicketVolume is a number large than 0 and less than 9
export function checkMonthlyTicketVolume(input) {
  return input ? /^[1-9][0-9]*$/.test(input) : true;
}

export function createMaxDate(date) {
  const maxDateEnv = moment()
    .add(date, "days")
    .format("YYYY-MM-DD");
  return maxDateEnv;
}

//Create function to verify whehter values are numbers large than 0 and less than 9
export function checkDailyDataVolume(input) {
  return input ? /^[0-9]{0,}$/.test(input) : true;
}

//Function to check Concurrent users is a numeric value
export function checkConcurrentUsers(input) {
  return input ? /^[0-9]{0,1}$/.test(input) : true;
}

//Create function to verify whehter value is a number large than 0
export function checkBenefitsExpected(input) {
  return input ? /^[0-9]{0,}$/.test(input) : true;
}

//Function to verify if enterprise id is valid
export function isEidValid(input) {
  return input.length === 0 ? false : /^[a-zA-Z._]*$/.test(input);
}

//Function to verify if secondary enterprise id is valid
export function checkSecondaryCustomerID(input) {
  return input.length === 0 ? false : /^[a-zA-Z._]*$/.test(input);
}

//Function to check notes values
export function checkNotesValue(input) {
  return input ? /^[^\s].*/.test(input) : false;
}

//Function to check project values
export function checkProjectValue(input) {
  return input ? /^[^\s].*/.test(input) : false;
}

//Function to check a license is requested
export function checkLicenses(input) {
  return input ? input > -1 : true;
}

export function checkTeams(input) {
  return input ? /^[A-Za-z0-9]{0,}$/.test(input) : true;
}
export function checkPOCname(input) {
  if (input === "")
    return true
  // return input.length === 0 ? false : /^[a-zA-Z._]*$/.test(input);
  return input.length === 0 ? false : /^[a-zA-Z._]*$/.test(input) && !input.includes('@');
}

//Function to verify if email format is valid
export function checkEmailFormat(input) {
  if (!input || input.trim() === "") {
    return true; // Allow empty for optional fields, forms will handle required validation
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(input.trim());
}
export async function checkServerStatus(url) {
  const headers = {
    "content-type": "application/json",
    Accept: "application/json",
  };
  try {
    const params = new URLSearchParams({ url: url }).toString();
    const urls = `${base.app.apiSite}order/server-check?${params}`
    const response = await axios.get(urls, {
      timeout: 5000, // 5 second timeout
    });
    return true;
  } catch (error) {
    return false;
  }
}
export async function hideSensitiveData(textValue) {
  const idToken = localStorage.getItem("token");       
  const headers = {
    "Content-Type": "application/json",
    "Accept": "application/json",
    "Authorization": idToken,
  };

  try {
    const response = await axios.post(
      `${base.app.apiSite}cipher/encrypt`,
      {
        dataValue: textValue,
      },
      {
        headers,
        timeout: 5000,
      }
    );
    return response.data;
  } catch (error) {
    return false;
  }
}
